import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe, Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems, ContextMenuItemModel } from '@syncfusion/ej2-angular-grids';
import { debounceTime, distinctUntilChanged, filter, finalize, switchMap, tap } from 'rxjs/operators';
import { isNumber } from 'highcharts';
import { MenuEventArgs  } from '@syncfusion/ej2-angular-navigations';

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { MovimientoService, MenuFuncionService, MonedaService, MedioPagoService, TipoMovimientoService, TenantService, ConsorcioService, ComunidadService } from '../../../../src/app/shared/services';
import { UnidadFuncionalService, ProveedorService, CuentaService, EstadoService, ConversionMonedaService } from '../../../../src/app/shared/services/index';

import { MenuFuncionCodes, Moneda, Movimiento, AlicuotaIva, MedioPago, TipoMovimiento, MedioPagoConstants, DialogConfirmRequest, GetSaldoRequestDto, SearchConsorcioRequest, SearchComunidadRequest } from '../../../../src/app/shared/model';
import { SearchUnidadFuncionalRequest, Comunidad, EstadoConstants, SearchProveedorRequest, Proveedor, SearchCuentaRequest, SearchEstadoRequest, Estado, GridPageSettings } from '../../../../src/app/shared/model';
import { Consorcio, UnidadFuncional, SearchMedioPagoRequest, SearchTipoMovimientoRequest, LocalStorageKeys, TenantFeatureFlags, DialogConfirmResponse, GenerarMovimientoPagoMasivoRequestDto,
  DialogCuentaSearchComponentResponseDto, DialogCuentaSearchComponentRequestDto, Cuenta, SearchMonedaRequest, GenerarMovimientoPagoDto, SearchMovimientoRequest, ExportMediaTypeConstants
 } from '../../../../src/app/shared/model';

import { DialogConfirmComponent } from '../../../../src/app/shared/components/modals/dialogConfirm.component';
import { DialogCuentaSearchComponent } from '../cuenta/components/dialogCuentaSearch.component';
import { ProcessFromPagosExcelItemDto, ProcessFromPagosExcelRequestDto } from '../../shared/model';

@Component({
  selector: 'app-movimientoPagoMasivo',
  templateUrl: './movimientoPagoMasivo.component.html',
  styles: []
})

export class MovimientoPagoMasivoComponent implements OnInit {

  @ViewChild('deudasPendientesGrid')
  public deudasPendientesGrid: GridComponent;

  formGroup: FormGroup;
  searchDeudaForm: FormGroup;

  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  isApproving: boolean = false;
  isRejecting: boolean = false;
  isValidating: boolean = false;
  isSearching: boolean = false;
  isSaving: boolean = false;
  isGenerandoRecibo: boolean = false;
  isDeudasExporting: boolean = false;
  isPagosUploading: boolean = false;
  isTemplateDownloading: boolean = false;
  isMonedaSearching: boolean = false;
  isTipoMovimientoSearching: boolean = false;
  isMedioPagoSearching: boolean = false;
  isMovimientoDeudaSearching: boolean = false;
  isCuentaImputadaSearching: boolean = false;
  isConsorcioSearching: boolean = false;
  isComunidadSearching: boolean = false;
  isUnidadesFuncionalesSearching: boolean = false;
  isProveedorAutoSearching: boolean = false;
  isEstadoSearching: boolean = false;
  isImportingDeudasPagos: boolean = false;

  isRosbaco: boolean = false;
  exportoDeudas: boolean = false;

  newFileDescripcion: string = "";

  canEdit: boolean = false;
  canView: boolean = false;
  canAddPago: boolean = false;
  canAddDeuda: boolean = false;
  canRecurrentes: boolean = false;
  canAnalizarDoc: boolean = false;
  canChangeState: boolean = false;

  pagosSaved: boolean = false;
  pagosIdGenerados: number[];

  debeSeleccionarCuentaImputada: boolean = false;

  msgError: string = "";
  item: Movimiento;

  alicuotaIvaList: AlicuotaIva[];
  monedaList: Moneda[];
  estadoList: Estado[];
  defaultMoneda: Moneda;
  medioPagoList: MedioPago[];
  tipoMovimientoList: TipoMovimiento[];
  deudasPendientesList: any[];
  deudasSeleccionadasList: any[] = [];
  saldoModosList: any[];
  consorcioList: Consorcio[];
  comunidadList: Comunidad[];
  ufList: UnidadFuncional[];
  filteredProveedorList: Proveedor[];
  cuenta: Cuenta;

  tenantFeatureFlags: TenantFeatureFlags;

  public totalesSeleccionados: any[] = [];
  public totalesBusqueda: any[] = [];

  pagosFileBase64: string | ArrayBuffer | null;
  pagosFileName: string | null = "";
  deudaPagosFileBase64: string | ArrayBuffer | null;
  deudaPagosFileName: string | null = "";

  totalDisponible: number = 0;
  totalPorPagar: number = 0;

  operacion: number = 0;
  medioPago: MedioPago | null;
  montoIva: number = 0;
  montoTotal: number = 0;
  montoCuota: number = 0;

  cuentaDetalle: Cuenta | null;
  cuentaImputada: Cuenta | null;
  cuentaImputadaSaldo: any;

  esUnicaCuentaImputadaDisponible: boolean = false;

  public deudaSelectionOptions?: SelectionSettingsModel;

  public contextMenuItems: ContextMenuItemModel[];

  private readonly gridColumns = [
    { field: 'FechaMovimiento', headerText: 'Fecha Movimiento' },
    { field: 'FechaVencimiento', headerText: 'Vencimiento' },
    { field: 'CuentaImputada', headerText: 'Referencia' },
    { field: 'Detalle', headerText: 'Detalle' },
    { field: 'TipoMovimientoNombre', headerText: 'Tipo' },
    { field: 'Monto', headerText: 'Total' },
    { field: 'Saldo', headerText: 'Pendiente' },
    { field: 'SaldoConvertido', headerText: 'Saldo Convertido' },
  ];

  constructor(
    private formBuilder: FormBuilder,
    private location: Location,
    public dialog: MatDialog,
    private sharedFunctions: SharedFunctions,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private router: Router,
    private menuService: MenuFuncionService,
    private monedaService: MonedaService,
    private conversionMonedaService: ConversionMonedaService,
    private medioPagoService: MedioPagoService,
    private tipoMovimientoService: TipoMovimientoService,
    private tenantService: TenantService,
    private consorcioService: ConsorcioService,
    private comunidadService: ComunidadService,
    private unidadFuncionalService: UnidadFuncionalService,
    private proveedorService: ProveedorService,
    private movimientoService: MovimientoService,
    private estadoService: EstadoService,
    private cuentaService: CuentaService
  ) {
    this.isRosbaco = this.sharedFunctions.isRosbacoUser();
    this.deudaSelectionOptions = { persistSelection: true, type: 'Multiple', checkboxOnly: true };
    this.buildForm();
  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.MOVIMIENTO).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
          this.isValidating = false;
          if (dataTenant != null && dataTenant.Success) {
            this.tenantFeatureFlags = dataTenant.Result;

            this.canAddPago = data.Result.some(x => x == MenuFuncionCodes.MOVIMIENTO_PAGO);
            if (!this.canAddPago) {
              this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
              this.onCancel();
              return false;
            }

            this.loadView();
          }
        },
        (err: HttpErrorResponse) => {
          this.isValidating = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.onCancel();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };


    // this.buildForm();

    this.getMediosPago();
    this.getMonedas();
    this.getTiposMovimientos();
    // this.getEstados();
    // this.getAlicuotaIva();

    this.getConsorcios();
    this.getComunidades();
    this.getProveedoresAutocomplete();

    this.getTiposMovimientos();

    this.selectMonedaDefault();
    this.selectMedioPagoDefault();
    this.selectTipoMovimientoDefault();

    this.contextMenuItems = this.sharedFunctions.initializeContextMenu(this.gridColumns);

    this.searchGastosPendientes();
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      'FechaMovimiento': [new Date(), Validators.required],
      // 'FechaVencimiento': [new Date()],
      // 'EstadoId': [EstadoConstants.ESTADO_MOVIMIENTO_CONFIRMADO, Validators.required],
      // 'CuentaDetalleId': [null],
      'TipoMovimientoId': [0, Validators.required],
      'MedioPagoId': [null],
      // 'AlicuotaIvaId': [null],
      // 'Moneda': [null],
      'MontoBase': [0, Validators.required],
      // 'MontoPercepciones': [0, Validators.required],
      'Detalle': [null, [Validators.required, Validators.maxLength(100)]],
      'Observacion': [null, Validators.maxLength(300)],
      'NroComprobante': [null, Validators.maxLength(100)],
    });

    var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
    if (cId != null && cId.length > 0 && cId > 0)
      cId = Number(cId);

    this.searchDeudaForm = this.formBuilder.group({
      'FechaMovimientoDesde': [null],
      'FechaMovimientoHasta': [new Date()],
      'FechaVencimientoDesde': [null],
      'FechaVencimientoHasta': [null],
      'Detalle': [null],
      'MonedaId': [null],

      'PedidoId': [null],
      'Contrato': [null],

      'NroDocumento': [null],
      'MailContacto': [null],
      'MovilContacto': [null],
      'Usuario': [null],
      'ComunidadId': [null],
      'ConsorcioId': [cId],
      'UnidadFuncionalId': [null],
      'Proveedor': [null],

      'VerSoloAsociadosAUfs': [false]
    });

    var filtros = this.sharedFunctions.getReporteFiltros("app-movimientoPagoMasivo");
    if (filtros != null) {
      this.searchDeudaForm.patchValue(filtros);
      if (filtros.ComunidadId != null && filtros.ComunidadId > 0)
        this.onDeudaFiltroUfComunidadSelect(false);
    }
  }

  onTabChange(event: any): void {
    if (event.index === 1) {
      //Tab de Importador de Movimientos de Pagos desde Archivo
      // if (this.pagosGrid != null) {
      //   this.pagosGridContextMenuItems = this.sharedFunctions.initializeContextMenu(this.pagosGridColumns);
      //   this.pagosGrid.refresh();
      // }
    }
    else if (event.index === 0) {
      //Tab de Buscador de Movimientos de Deuda
      if (this.deudasPendientesGrid != null) {
        this.contextMenuItems = this.sharedFunctions.initializeContextMenu(this.gridColumns);
        this.deudasPendientesGrid.refresh();
      }
    }
  }

  isProcessing() {
    return (this.isSearching || this.isSaving || this.isApproving || this.isRejecting || this.isDeudasExporting || this.isPagosUploading || this.isImportingDeudasPagos);
  }

  getEstados() {
    if (!this.canChangeState)
      return false;

    var r = new SearchEstadoRequest(null, null, true, "Nombre", null, null, true);
    this.isEstadoSearching = true;

    this.estadoService.searchMovimientoEstados(r).subscribe(data => {
      this.isEstadoSearching = false;
      this.estadoList = data?.result?.filter(f => f.Id != EstadoConstants.ESTADO_MOVIMIENTO_CANCELADO);

      this.formGroup.get('EstadoId')?.setValue(EstadoConstants.ESTADO_MOVIMIENTO_CONFIRMADO);
    },
    (err: HttpErrorResponse) => {
      this.isEstadoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getMonedas() {
    var r = new SearchMonedaRequest(null, null, true, "Codigo", null, null, null, true);
    this.isMonedaSearching = true;

    this.monedaService.search(r).subscribe(data => {
      this.isMonedaSearching = false;
      this.monedaList = data?.result;

      this.selectMonedaDefault();
    },
    (err: HttpErrorResponse) => {
      this.isMonedaSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  selectMonedaDefault() {
    // if (this.monedaList != null && this.monedaList.length == 1 && (this.item?.MonedaId == null || this.item.MonedaId <= 0)) {
    //   this.formGroup.get('Moneda')?.setValue(this.monedaList[0]);
    //   this.onMonedaSelect();
    // }
  }

  getMediosPago() {
    var r = new SearchMedioPagoRequest(null, null, true, "Nombre", null, null, true);
    this.isMedioPagoSearching = true;

    this.medioPagoService.search(r).subscribe(data => {
      this.isMedioPagoSearching = false;
      this.medioPagoList = data?.result?.filter(f => f != null && f.Id != MedioPagoConstants.CreditoEnCuenta);

      this.selectMedioPagoDefault();
    },
    (err: HttpErrorResponse) => {
      this.isMedioPagoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  selectMedioPagoDefault() {
    if (this.medioPagoList != null && (this.item?.MedioPagoId == null || this.item.MedioPagoId <= 0)) {
      this.formGroup.get('MedioPagoId')?.setValue(null);

      if (this.medioPagoList.length == 1)
        this.formGroup.get('MedioPagoId')?.setValue(this.medioPagoList[0]?.Id);
      else
        this.formGroup.get('MedioPagoId')?.setValue(this.medioPagoList.find(f => f.Id == MedioPagoConstants.Efectivo)?.Id);
    }

    this.onMedioPagoSelect();
  }

  getTiposMovimientos() {
    var r = new SearchTipoMovimientoRequest(null, null, true, "Nombre", null, null, 1, null, true);
    this.isTipoMovimientoSearching = true;

    this.tipoMovimientoService.search(r).subscribe(data => {
      this.isTipoMovimientoSearching = false;
      this.tipoMovimientoList = data?.result;

      this.selectTipoMovimientoDefault();
    },
    (err: HttpErrorResponse) => {
      this.isTipoMovimientoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  selectTipoMovimientoDefault() {
    if (this.tipoMovimientoList != null && this.tipoMovimientoList.length == 1 && (this.item?.TipoMovimientoId == null || this.item.TipoMovimientoId <= 0)) {
      this.formGroup.get('TipoMovimientoId')?.setValue(this.tipoMovimientoList[0]?.Id);
    }
  }

  getConsorcios() {
    if (!this.tenantFeatureFlags?.HabilitarGestionConsorcio)
      return;

    var r = new SearchConsorcioRequest(null, null, true, "Nombre", null, null, null, null, null, true);
    this.isConsorcioSearching = true;

    this.consorcioService.search(r).subscribe(data => {
      this.isConsorcioSearching = false;
      this.consorcioList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isConsorcioSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getComunidades() {
    var r = new SearchComunidadRequest(null, null, true, "Nombre", null, null, null, null, null, true);
    this.isComunidadSearching = true;

    this.comunidadService.search(r).subscribe(data => {
      this.isComunidadSearching = false;
      this.comunidadList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isComunidadSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getProveedoresAutocomplete() {
    this.searchDeudaForm.get('Proveedor')?.valueChanges
      .pipe(
        filter(res => {
          return res && res !== null && res.length >= 3
        }),
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => {
          this.filteredProveedorList = [];
          this.isProveedorAutoSearching = true;
        }),
        switchMap(value => this.proveedorService.search(new SearchProveedorRequest(null, null, true, "RazonSocial", null, !isNumber(parseInt(value)) ? value : null, isNumber(parseInt(value)) ? value : null, null, null, null, true))
          .pipe(
            finalize(() => {
              this.isProveedorAutoSearching = false;
            }),
          )
        )
      )
      .subscribe((data: any) => {
        if (data != null && data.result != null)
          this.filteredProveedorList = data.result;
        else
          this.filteredProveedorList = [];
        // (this.filteredProveedorList, 'lista proveedor')
      });
  }

  displayProveedor(proveedor: Proveedor): string {
    return proveedor && proveedor?.RazonSocial ? proveedor.RazonSocial : '';
  }

  onDeudaFiltroUfComunidadSelect(clearUf: boolean = true) {
    if (!this.tenantFeatureFlags?.HabilitarGestionUf)
      return;

    if (clearUf)
      this.searchDeudaForm?.get("UnidadFuncionalId")?.setValue(null);

    var cId = this.searchDeudaForm?.get("ComunidadId")?.value;
    if (cId == null || cId <= 0) {
      this.ufList = [];
      return false;
    }

    var r = new SearchUnidadFuncionalRequest(null, null, true, "Codigo", null, null, null, null, null, null, cId, null, true);
    this.isUnidadesFuncionalesSearching = true;

    this.unidadFuncionalService.search(r).subscribe(data => {
      this.isUnidadesFuncionalesSearching = false;
      this.ufList = data.result;
    },
    (err: HttpErrorResponse) => {
      this.isUnidadesFuncionalesSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  onMedioPagoSelect() {
    this.medioPago = (this.medioPagoList?.find(f => f.Id == this.formGroup.get("MedioPagoId")?.value) ?? null);

    if (this.medioPago?.Id != MedioPagoConstants.CreditoEnCuenta)
      this.cuentaImputada = null;

    this.debeSeleccionarCuentaImputada = this.medioPago?.Id == MedioPagoConstants.CreditoEnCuenta;
  }

  doMovimientoDelete(movimientoId: number) {
    if (movimientoId != null && movimientoId > 0 && this.deudasPendientesList != null) {
      var index = this.deudasPendientesList?.findIndex(f => f.Id == movimientoId);
      if (index >= 0) {
        this.deudasPendientesList.splice(index, 1);
        this.deudasPendientesGrid.refresh();

        this.calcularTotalSeleccionado();
      }
    }
  }

  getErrorFechaMovimiento() {
    return this.formGroup.get('FechaMovimiento')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorTipoMovimientoId() {
    return this.formGroup.get('TipoMovimientoId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorEstadoId() {
    return this.formGroup.get('EstadoId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorDetalle() {
    var v = this.formGroup.get('Detalle');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorMonedaId() {
    return this.formGroup.get('Moneda')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorMontoBase() {
    return this.formGroup.get('MontoBase')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorMontoPercepciones() {
    return this.formGroup.get('MontoPercepciones')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErroNroComprobante() {
    var v = this.formGroup.get('NroComprobante');
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorMedioPagoId() {
    return this.formGroup.get('MedioPagoId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorAlicuotaIvaId() {
    return this.formGroup.get('AlicuotaIvaId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorObservacion() {
    var v = this.formGroup.get('Observacion');
    if (v?.hasError('maxlength'))
      return 'Límite de 300 caracteres alcanzado';
    return '';
  }

  getErrorCantidadCuotas() {
    var v = this.formGroup.get('CantidadCuotas');
    if (v?.hasError('min'))
      return 'Debe ingresar un valor mayor a 0';
    return '';
  }

  getErrorFechaInicioCuota() {
    var v = this.formGroup.get('FechaInicioCuota');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    return '';
  }

  getErrorDiasRepeticionCuotas() {
    var v = this.formGroup.get('DiasRepeticionCuotas');
    if (v?.hasError('maxlength'))
      return 'Límite de 5 caracteres alcanzado';
    return '';
  }

  getErrorPorcentajeAjusteCuota() {
    var v = this.formGroup.get('PorcentajeAjusteCuota');
    if (v?.hasError('min'))
      return 'El porcentaje debe ir entre 0 y 100';
    if (v?.hasError('max'))
      return 'El porcentaje debe ir entre 0 y 100';
    return '';
  }

  onMonedaSelect() {
    // if (this.operacion > 0 && this.showStep2) {
    //   this.searchGastosPendientes();
    //   this.verificarCuentaImputadaUnica();
    // }
    this.calcularTotalSeleccionado();
  }

  clearDeudaDate(formFieldName: string) {
    if (formFieldName != null && formFieldName.length > 0) {
        if (this.searchDeudaForm.get(formFieldName) != null && this.searchDeudaForm.get(formFieldName)?.value)
            this.searchDeudaForm?.get(formFieldName)?.setValue(null);
    }
  }

  searchGastosPendientes() {
    if (this.operacion < 0)
      return false;

    this.sharedFunctions.setReporteFiltros("app-movimientoPagoMasivo", this.searchDeudaForm.getRawValue());
    var search = new SearchMovimientoRequest(null, null, true, "FechaMovimiento", null, null, null, null, null, null, null, null, null, null, null, null,
      null, null, null, null, null, null, null, null, null, null, null, null, null, null, true, true, false, null);

    search = {
      ...search,
      ...this.searchDeudaForm.value,
      ... {
        Estados: [ EstadoConstants.ESTADO_MOVIMIENTO_CONFIRMADO.toString() ],
        VerSoloDeudasPendientes: true,
        VerSoloActivos: true,
        MonedaConversionId: this.formGroup.get("Moneda")?.value?.Id,
        ProveedorId: this.searchDeudaForm.get("Proveedor")?.value?.Id
      }
    }

    this.isMovimientoDeudaSearching = true;
    this.movimientoService.search(search).subscribe(data => {
      this.isMovimientoDeudaSearching = false;
      this.exportoDeudas = false;
      this.deudasPendientesList = data?.result;

      for (var i=0; i<this.deudasPendientesList.length; i++)
        this.deudasPendientesList[i].MontoPago = 0;

      this.calcularTotalSeleccionado();
    },
    (err: HttpErrorResponse) => {
      this.isMovimientoDeudaSearching = false;
      this.sharedFunctions.handleError(err, true);
    })

    setTimeout(() => {
      this.sharedFunctions.setColumnsVisibility("FechaMovimiento", this.deudasPendientesGrid, this.gridColumns, false);
      this.sharedFunctions.setColumnsVisibility("FechaVencimiento", this.deudasPendientesGrid, this.gridColumns, false);
      this.sharedFunctions.setColumnsVisibility("TipoMovimientoNombre", this.deudasPendientesGrid, this.gridColumns, false);
      this.sharedFunctions.setColumnsVisibility("Monto", this.deudasPendientesGrid, this.gridColumns,false);
      this.sharedFunctions.setColumnsVisibility("SaldoConvertido", this.deudasPendientesGrid, this.gridColumns,false);
    }, 500);
  }

  onGuardar() {
    var deudasPagadasList = this.deudasPendientesList?.filter(f => f.MontoPago != null && f.MontoPago > 0);
    if (deudasPagadasList == null || deudasPagadasList.length == 0) {
      this.sharedFunctions.showMessage("No hay deudas en el listado que tengan un pago con importe mayor a 0", "Error");
      return false;
    }

    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: new DialogConfirmRequest(
        "Confirmación de Operación",
        "¿Está seguro de que desea cargar " + deudasPagadasList.length + " movimientos?",
        "Sí",
        "No"
      )
    });

    dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
      if (result != null && result.Accepted) {
        this.doGeneracionPago();
      }
    });
  }

  doGeneracionPago() {

    this.pagosSaved = false;
    this.pagosIdGenerados = [];

    var deudasPagadasList = this.deudasPendientesList?.filter(f => f.MontoPago != null && f.MontoPago > 0);
    if (deudasPagadasList == null || deudasPagadasList.length == 0) {
      this.sharedFunctions.showMessage("No hay deudas en el listado que tengan un pago con importe mayor a 0", "Error");
      return false;
    }

    var r = new GenerarMovimientoPagoMasivoRequestDto([], true);

    for (var i=0; i<deudasPagadasList.length; i++) {

      // if (this.item.Adjuntos[i].CuentaImputada != null)
      //   this.item.Adjuntos[i].CuentaImputada.MonedaId = (this.item.Adjuntos[i].MonedaId ?? 0);

      // if (this.item.Adjuntos[i].CuentaDetalle != null)
      //   this.item.Adjuntos[i].CuentaDetalle.MonedaId = (this.item.Adjuntos[i].MonedaId ?? 0);

      var p = new GenerarMovimientoPagoDto(
        0,
        this.formGroup.get("TipoMovimientoId")?.value,
        null, //this.item.Adjuntos[i].CuentaImputadaId,
        null, //this.item.Adjuntos[i].CuentaImputada,
        null, //this.item.Adjuntos[i].CuentaDetalleId,
        null, //this.item.Adjuntos[i].CuentaDetalle,
        EstadoConstants.ESTADO_MOVIMIENTO_CONFIRMADO,
        deudasPagadasList[i].MonedaId,
        this.formGroup.get("MedioPagoId")?.value,
        null, //this.item.Adjuntos[i].AlicuotaIvaId,
        this.formGroup.get("FechaMovimiento")?.value,
        null,
        deudasPagadasList[i].MontoPago,
        0,
        this.formGroup.get("Detalle")?.value,
        this.formGroup.get("Observacion")?.value,
        null, //this.item.Adjuntos[i].NroComprobante,
        [],
        [ deudasPagadasList[i] ] //El pago que se da de alta queda asociado a la deuda
      );

      r.Pagos.push(p);
      // console.log('generarPago request: ', r);
    }

    // console.log('generarPago request: ', r);

    this.isSaving = true;
    this.movimientoService.generarPagos(r).subscribe(data => {
      this.isSaving = false;
      if (data != null && data.Success && data.Result != null && data.Result.length > 0) {
        this.pagosSaved = true;
        this.pagosIdGenerados = data.Result?.map(s => s.MovimientoPagoId);

        this.sharedFunctions.showMessage("Se generaron correctamente " + data.Result.length + " pagos!", "Operación Exitosa!");

        for (var i=0; i<this.deudasPendientesList.length; i++) {
          this.deudasPendientesList[i].PagoId = data.Result?.find(f => f.MovimientoDeudaId == this.deudasPendientesList[i].Id)?.MovimientoPagoId;
        }
        this.deudasPendientesGrid.refresh();
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSaving = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  openDialogCuentaParaAcreditarSobranteSearch() {
    if (this.isProcessing())
        return;

    this.cuentaImputada = null;

    var monedaId = this.formGroup.get("Moneda")?.value?.Id;
    if (monedaId == null || monedaId <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar una moneda antes de poder seleccionar la cuenta crédito", "Error");
      return false;
    }

    //Dialog para seleccionar a que cuenta se le asignara el saldo excedente de un pago (no aplica para deudas)
    const dialogRef = this.dialog.open(DialogCuentaSearchComponent, {
      width: '90%',
      data: new DialogCuentaSearchComponentRequestDto(this.tenantFeatureFlags, false, false, true, true, true, this.formGroup.get("Moneda")?.value?.Id, this.formGroup.get("Moneda")?.value?.Codigo, false)
    });

    dialogRef.afterClosed().subscribe((result: DialogCuentaSearchComponentResponseDto) => {
      if (result != null && !result.Cancelled) {

        var cargoCuenta = this.checkCuentaImputada(result.Item);
        if (!cargoCuenta) {
          this.sharedFunctions.showMessage("Debe seleccionar una cuenta para continuar", "Error");
          return false;
        }

        this.cuentaImputada = result.Item;
        this.doGeneracionPago();
      }
    });
  }

  openDialogCuentaCreditoSearch() {
    if (this.isProcessing())
        return;

    var monedaId = this.formGroup.get("Moneda")?.value?.Id;
    if (monedaId == null || monedaId <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar una moneda antes de poder seleccionar la cuenta crédito", "Error");
      return false;
    }

    //Dialog para seleccionar desde que cuenta se tomara credito excedente para realizar un pago (no aplica en deudas)
    const dialogRef = this.dialog.open(DialogCuentaSearchComponent, {
        width: '90%',
        data: new DialogCuentaSearchComponentRequestDto(this.tenantFeatureFlags, false, false, true, true, true, monedaId, this.formGroup.get("Moneda")?.value?.Codigo, true)
    });

    dialogRef.afterClosed().subscribe((result: DialogCuentaSearchComponentResponseDto) => {
      if (result != null && !result.Cancelled) {
        var cargoCuenta = this.checkCuentaImputada(result.Item);
        if (!cargoCuenta) {
          this.sharedFunctions.showMessage("Debe seleccionar una cuenta para continuar", "Error");
          return false;
        }

        this.cuentaImputadaSaldo = { Moneda: "Sin saldo disponible", Saldo: null };
        this.cuentaImputada = result.Item;

        if (this.cuentaImputada != null && this.cuentaImputada.Id > 0) {
          var r = new GetSaldoRequestDto(this.cuentaImputada.Id, null, null, null, null, null, null);
          this.isCuentaImputadaSearching = true;
          this.movimientoService.getSaldo(r).subscribe(data => {
            this.isCuentaImputadaSearching = false;
            if (data != null && data.Success && data.Result != null && data.Result.Saldos != null && data.Result.Saldos.length > 0) {
              this.cuentaImputadaSaldo = { Saldo: data.Result.Saldos[0].SaldoAFavor, Moneda: data.Result.Saldos[0].Moneda };

              this.formGroup.get("Moneda")?.setValue(this.monedaList.find(f => f.Codigo == data.Result.Saldos[0].Moneda));
              this.formGroup.get("Monto")?.setValue(data.Result.Saldos[0].SaldoAFavor);
            }
          },
          (err: HttpErrorResponse) => {
            this.isCuentaImputadaSearching = false;
            this.sharedFunctions.handleError(err, true);
          })
        }
      }
    });
  }

  openDialogCuentaDeudaSearch() {
    if (this.isProcessing())
        return;

    var monedaId = this.formGroup.get("Moneda")?.value?.Id;
    if (monedaId == null || monedaId <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar una moneda antes de poder seleccionar la cuenta a la cual asociar la deuda", "Error");
      return false;
    }

    //Dialog para seleccionar a que cuenta se le imputa un movimiento de deuda (no se usa en pagos)
    const dialogRef = this.dialog.open(DialogCuentaSearchComponent, {
        width: '90%',
        data: new DialogCuentaSearchComponentRequestDto(this.tenantFeatureFlags, false, false, true, true, true, monedaId, this.formGroup.get("Moneda")?.value?.Codigo, null)
    });

    dialogRef.afterClosed().subscribe((result: DialogCuentaSearchComponentResponseDto) => {
      if (result != null && !result.Cancelled) {
        var cargoCuenta = this.checkCuentaImputada(result.Item);
        if (!cargoCuenta) {
          this.sharedFunctions.showMessage("Debe seleccionar una cuenta para continuar", "Error");
          return false;
        }

        this.cuentaImputada = result.Item;
      }
    });
  }

  verificarCuentaImputadaUnica() {
    this.esUnicaCuentaImputadaDisponible = false;

    //Traigo las primeras 3 cuentas disponibles que tenga el usuario. Si viene solo 1, la asigno como default
    var r = new SearchCuentaRequest(3, 0, true, "", null, null, null, null, null, this.formGroup.get("Moneda")?.value?.Id, null, null, null,
      null, null, null, true, null, false, true);

    this.cuentaService.search(r).subscribe(data => {
      var cuentaList = data?.result;
      if (cuentaList != null && cuentaList.length == 1) {
        this.esUnicaCuentaImputadaDisponible = true;
        this.cuentaImputada = cuentaList[0];
      }
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    })
  }

  getCuentaDefault() {
    var cuentaResult = new Cuenta(
      0,
      "", true,
      this.monedaList[0]?.Id,
      null, null, null, null, null, null, null, true,
      null,
      null,
      null,
      null,
      this.comunidadList[0]?.Id,
      this.comunidadList[0]?.Nombre,
      null,
      null,
      null,
      null,
    );

    return cuentaResult;
  }

  openDialogCuentaDetalleSearch() {
    if (this.isProcessing())
        return;

    var monedaId = this.formGroup.get("Moneda")?.value?.Id;
    if (monedaId == null || monedaId <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar una moneda antes de poder seleccionar la cuenta a la cual asociar la deuda", "Error");
      return false;
    }

    //Dialog para seleccionar a que cuenta se le imputa un movimiento de deuda (no se usa en pagos)
    const dialogRef = this.dialog.open(DialogCuentaSearchComponent, {
      width: '90%',
      data: new DialogCuentaSearchComponentRequestDto(this.tenantFeatureFlags, true, true, false, false, false, monedaId, this.formGroup.get("Moneda")?.value?.Codigo, null)
    });

    dialogRef.afterClosed().subscribe((result: DialogCuentaSearchComponentResponseDto) => {
      if (result != null && !result.Cancelled) {
        var cargoCuenta = this.checkCuentaDetalle(result.Item);
        if (!cargoCuenta) {
          this.sharedFunctions.showMessage("Debe seleccionar una cuenta para continuar", "Error");
          return false;
        }

        this.cuentaDetalle = result.Item;
      }
    });
  }

  checkCuentaImputada(datosCuenta) {
    return (datosCuenta != null && ((datosCuenta.ComunidadId ?? 0) + (datosCuenta.ConsorcioId ?? 0) + (datosCuenta.UnidadFuncionalId ?? 0) > 0));
  }

  checkCuentaDetalle(datosCuenta) {
    if (datosCuenta == null)
      return false;

    if ((datosCuenta.ProveedorId ?? 0) + (datosCuenta.PersonaId ?? 0) > 0)
      return true;
    else {
      if ((datosCuenta.PersonaId ?? 0) == 0 && datosCuenta.Persona != null)
        return true;
    }

    return false;
  }

  cleanCuentaDetalle() {
    this.cuentaDetalle = null;
  }

  cleanCuentaImputada() {
    this.cuentaImputadaSaldo = null;
    this.cuentaImputada = null;
  }

  cleanCuentaDeuda() {
    this.cuentaImputada = null;
  }

  onCancel() {
    this.location.back();
  }

  calcularTotalSeleccionado() {
    this.totalesSeleccionados = [];
    this.totalesBusqueda = [];

    var multiSelection = this.deudasPendientesList;
    if (multiSelection != null && multiSelection.length > 0) {
      for (var i=0; i<multiSelection.length; i++) {
        var item = (multiSelection[i] as any);

        if (item.MonedaPago != null && item.MonedaPago?.Codigo != null && item.MonedaPago?.Codigo.length > 0) {
          var index = this.totalesSeleccionados.findIndex(v => v.key == item.MonedaPago?.Codigo);
          if (index == null || index < 0) {
            this.totalesSeleccionados.push({ key: item.MonedaPago?.Codigo, value: 0 });
            index = this.totalesSeleccionados.length - 1;
          }
          this.totalesSeleccionados[index].value += parseFloat(item.MontoPago);
        }

        if (item.Moneda != null && item.Moneda.length > 0) {
          var index2 = this.totalesBusqueda.findIndex(v => v.key == item.Moneda);
          if (index2 == null || index2 < 0) {
            this.totalesBusqueda.push({ key: item.Moneda, value: 0 });
            index2 = this.totalesBusqueda.length - 1;
          }
          this.totalesBusqueda[index2].value += parseFloat(item.Saldo);
        }
      }
    }
  }

  convertFilePagosToBase64(event) {
    this.pagosFileBase64 = null;
    this.pagosFileName = null;

    const file = event.target.files[0];

    if (file != null) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // this.backofficeImageBase64 = reader.result;
      };
      reader.onloadend = () => {
        // var fileExtension = (file?.name?.split('.')?.pop() ?? "");
        // if (fileExtension == null || fileExtension?.toLowerCase() != "csv") {
        //   this.sharedFunctions.showMessage("Solo puede adjuntar archivos CSV", "Error");
        // }

        this.pagosFileBase64 = reader.result;
        this.pagosFileName = file?.name;
        // console.log(reader.result);
      };
    }
  }

  downloadTemplatePagos() {
    this.isTemplateDownloading = true;
    this.movimientoService.downloadImportPagosTemplate().subscribe((data: Blob) => {
      this.isTemplateDownloading = false;
      var fileUrl = URL.createObjectURL(data);

      var anchor = document.createElement("a");
      anchor.download = "Template_Importacion_Pagos.xlsx";
      anchor.href = fileUrl;
      anchor.click();
    },
    (err: HttpErrorResponse) => {
      this.isTemplateDownloading = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  uploadPagosFromArchivo() {
    this.isPagosUploading = true;
  }

  exportarDeudas() {
    var search = new SearchMovimientoRequest(null, null, true, "FechaMovimiento", null, null, null, null, null, null, null, null, null, null, null, null,
      null, null, null, null, null, null, null, null, null, null, null, null, null, null, true, true, false, null);

    search = {
      ...search,
      ...this.searchDeudaForm.value,
      ... {
        Estados: [ EstadoConstants.ESTADO_MOVIMIENTO_CONFIRMADO.toString() ],
        VerSoloDeudasPendientes: true,
        VerSoloActivos: true,
        MonedaConversionId: this.formGroup.get("Moneda")?.value?.Id,
        ProveedorId: this.searchDeudaForm.get("Proveedor")?.value?.Id
      }
    }

    this.isDeudasExporting = true;
    this.movimientoService.exportSearchPagosMasivos(search, ExportMediaTypeConstants.Excel).subscribe((data: Blob) => {
      this.isDeudasExporting = false;
      var fileUrl = URL.createObjectURL(data);

      var anchor = document.createElement("a");
      anchor.download = "Deudas_" + this.datePipe.transform(new Date(),"yyyy-MM-dd") + this.sharedFunctions.getFileExtension(ExportMediaTypeConstants.Excel);
      anchor.href = fileUrl;
      anchor.click();

      this.exportoDeudas = true;
    },
    (err: HttpErrorResponse) => {
      this.isDeudasExporting = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  importarDeudasPago() {

    if (this.deudaPagosFileBase64 == null) {
      this.sharedFunctions.showMessage("Debe adjuntar un archivo para poder procesarlo", "Error");
      this.deudaPagosFileBase64 = null;
      this.deudaPagosFileName = null;
      return false;
    }

    var r = new ProcessFromPagosExcelRequestDto(this.deudaPagosFileName, this.deudaPagosFileBase64);

    this.isImportingDeudasPagos = true;
    this.movimientoService.processPagosExcel(r).subscribe(data => {
      this.isImportingDeudasPagos = false;
      this.deudaPagosFileBase64 = null;
      this.deudaPagosFileName = null;

      if (data != null && data.Success && data.Result != null) {
        this.matchResultadoDeudaPago(data.Result?.Pagos);
        this.sharedFunctions.showMessage("Se procesaron correctamente los pagos. Por favor revise el listado de deudas para confirmar que todo quedó configurado como desea", "Procesamiento de Pagos");
      }
      else
        this.sharedFunctions.showMessage("Ocurrió un error realizando la importación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isImportingDeudasPagos = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  matchResultadoDeudaPago(pagosArchivo: ProcessFromPagosExcelItemDto[]) {
    if (pagosArchivo != null && pagosArchivo.length > 0) {
      for (var i=0; i<pagosArchivo.length; i++) {
        var deudaIndex = this.deudasPendientesList.findIndex(f => f.Id == pagosArchivo[i].DeudaId);

        if (deudaIndex != null && deudaIndex >= 0) {
          this.deudasPendientesList[deudaIndex].MonedaPagoId = pagosArchivo[i].MonedaPagoId;
          this.deudasPendientesList[deudaIndex].MonedaPago = new Moneda(pagosArchivo[i].MonedaPagoId, pagosArchivo[i].Moneda, pagosArchivo[i].Moneda, true);
          this.deudasPendientesList[deudaIndex].MontoPago = pagosArchivo[i].MontoPagado;
        }
      }

      this.deudasPendientesGrid.refresh();
      this.calcularTotalSeleccionado();
    }
  }

  convertFileDeudasPagosToBase64(event) {
    this.deudaPagosFileBase64 = null;
    this.deudaPagosFileName = null;

    const file = event.target.files[0];

    if (file != null) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // this.backofficeImageBase64 = reader.result;
      };
      reader.onloadend = () => {
        // var fileExtension = (file?.name?.split('.')?.pop() ?? "");
        // if (fileExtension == null || fileExtension?.toLowerCase() != "csv") {
        //   this.sharedFunctions.showMessage("Solo puede adjuntar archivos CSV", "Error");
        // }

        this.deudaPagosFileBase64 = reader.result;
        this.deudaPagosFileName = file?.name;
        // console.log(reader.result);
        this.importarDeudasPago();
      };
    }
  }

  autocompletarPagos() {
    if (this.deudasPendientesList != null && this.deudasPendientesList.length > 0) {
      for (var i=0; i<this.deudasPendientesList.length; i++) {
        this.deudasPendientesList[i].MonedaPagoId = this.deudasPendientesList[i].MonedaId;
        this.deudasPendientesList[i].MonedaPago = new Moneda(this.deudasPendientesList[i].MonedaId, this.deudasPendientesList[i].Moneda, this.deudasPendientesList[i].Moneda, true);
        this.deudasPendientesList[i].MontoPago = this.deudasPendientesList[i].Saldo * (this.deudasPendientesList[i].Saldo > 0 ? 1 : -1);
      }

      this.deudasPendientesGrid.refresh();
      this.calcularTotalSeleccionado();
    }
  }

  onDeudaGridFieldChange(movimientoId: number, event: any) {
    // console.log("onDeudaGridFieldChange - movimientoId: " + movimientoId, event);
    if (movimientoId != null && movimientoId > 0 && this.deudasPendientesList != null) {

      var controlName = event?.target?.name ?? event?.targetElement?.name ?? event?.source?.ngControl?.name;
      var controlValue = event?.value ?? event?.target?.value ?? event?.option?.value;
      // console.log("onDeudaGridFieldChange - controlName: " + controlName + " - controlValue: " + controlValue);

      var index = this.deudasPendientesList?.findIndex(f => f.Id == movimientoId);
      if (index >= 0) {
        switch (controlName) {
          // case "FechaMovimiento":
          //   this.deudasPendientesList[index].FechaMovimiento = controlValue;
          //   break;
          // case "FechaVencimiento":
          //   this.deudasPendientesList[index].FechaVencimiento = controlValue;
          //   break;
          // case "Detalle":
          //   this.deudasPendientesList[index].Detalle = controlValue;
          //   break;
          // case "TipoMovimientoId":
          //   this.deudasPendientesList[index].TipoMovimientoId = controlValue;
          //   break;
          case "MonedaPagoId":
          case "MonedaPago":
            this.deudasPendientesList[index].MonedaPagoId = controlValue;
            this.deudasPendientesList[index].MonedaPago = this.monedaList?.find(f => f.Id == controlValue);

            if (this.deudasPendientesList[index].MonedaId != this.deudasPendientesList[index].MonedaPagoId) {
              this.conversionMonedaService.getUltimaCotizacion(this.deudasPendientesList[index].MonedaId, this.deudasPendientesList[index].MonedaPagoId).subscribe(data => {
                if (data.Success) {
                  this.deudasPendientesList[index].SaldoConvertido = data.Result.CoeficienteConversion * this.deudasPendientesList[index].Saldo;
                  this.deudasPendientesGrid.refresh();

                  this.calcularTotalSeleccionado();
                }
              },
              (err: HttpErrorResponse) => {
                this.sharedFunctions.handleError(err);
              });
            }
            else {
              this.deudasPendientesList[index].SaldoConvertido = this.deudasPendientesList[index].Saldo;
              this.deudasPendientesGrid.refresh();

              this.calcularTotalSeleccionado();
            }
            break;
          // case "AlicuotaIvaId":
          //   this.deudasPendientesList[index].AlicuotaIvaId = controlValue;
          //   this.calcularTotalPorPagar();
          //   break;
          case "MontoPago":
            this.deudasPendientesList[index].MontoPago = parseFloat(controlValue);
            this.calcularTotalSeleccionado();
            break;
          // case "EstadoId":
          //   this.deudasPendientesList[index].EstadoId = controlValue;
          //   break;
        }

        this.deudasPendientesGrid.refresh();
        // this.calcularTotalSeleccionado();
      }
    }
  }

  onGeneracionRecibo() {
    if (this.pagosIdGenerados == null || this.pagosIdGenerados.length == 0) {
      this.sharedFunctions.showMessage("No se encontraron pagos generados", "Error");
      return false;
    }

    for (var i=0; i<this.pagosIdGenerados.length; i++)
      this.doGeneracionReciboPago(this.pagosIdGenerados[i]);
  }

  doGeneracionReciboPago(movId: number) {
    this.isGenerandoRecibo = true;
    this.movimientoService.generarReciboPago(movId).subscribe((data: Blob) => {
      this.isGenerandoRecibo = false;
      var fileUrl = URL.createObjectURL(data);

      var anchor = document.createElement("a");
      anchor.download = "ReciboPago_" + movId + "_" + this.datePipe.transform(new Date(),"yyyy-MM-dd") + ".pdf";
      anchor.href = fileUrl;
      anchor.click();
    },
    (err: HttpErrorResponse) => {
      this.isGenerandoRecibo = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onRestart() {
    this.sharedFunctions.reloadCurrentRoute();
  }

  contextMenuOpen(args: any): void {
    args.cancel = this.sharedFunctions.updateMenuItemState(args.items,args.event.target, this.deudasPendientesGrid, this.gridColumns);
  }

  contextMenuClick(args: MenuEventArgs): void {
    if (!args.item.id) return;
    const { id } = args.item;
    this.sharedFunctions.setColumnsVisibility(id, this.deudasPendientesGrid, this.gridColumns)
  }
}
